module.exports = __webpack_public_path__ + "static/media/slide-2.5ebe74e1.png";